<template>
  <card  v-loading="loading" class="signin">
    <restore-password-modal :modalIsVisible="restoreModalIsVisible" v-on:closeModal="restoreModalIsVisible = false"/>
    <div class="card-header">
        <h5> {{ $t('Enter') }}</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="signin">
        <fg-input
          name="login"
          ref="login"
          addon-left-icon="now-ui-icons users_single-02"
          :placeholder="$t('Login')"
          v-model="login"
          v-validate="modelValidations.login"
          :error="getError('login')"
        />
        <fg-input
          type="password"
          name="password"
          addon-left-icon="now-ui-icons objects_key-25"
          :placeholder="$t('Password')"
          v-model="password"
          v-validate="modelValidations.password"
          :error="getError('password')"
        >
          <template v-slot:helpBlock>
            <span class="form-text">
              <el-button type="text" class="forgot-password-btn" @click="restoreModalIsVisible = true">Забыли пароль?</el-button>
            </span>
          </template>
        </fg-input>
        <n-button
          type="primary"
          nativeType="submit"
          wide=""
          round=""
        >
          {{ $t('Log in') }}
        </n-button>
      </form>
    </div>
  </card>
</template>

<script>
import { FormGroupInput as FgInput } from '@/ui'
import { Dialog, Button } from 'element-ui'
import axios from 'axios'
import RestorePasswordModal from '@/components/RestorePasswordModal'

export default {
  name: 'Auth',
  data () {
    return {
      login: '',
      password: '',
      modelValidations: {
        login: {
          required: true
        },
        password: {
          required: true
        }
      },
      restoreModalIsVisible: false,
      loading: false,
      error: ''
    }
  },
  components: {
    RestorePasswordModal,
    FgInput,
    [Button.name]: Button,
    [Dialog.name]: Dialog
  },
  methods: {
    signin () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          axios.post('authorize/login', {
            'login': this.login,
            'password': this.password
          })
            .then(() => {
              localStorage.setItem('auth', true)
              this.loading = false
              this.$router.push('/dashboard')
            }).catch(error => {
              this.loading = false
              this.$notify(
                {
                  message: error.response.data.error,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
            })
        }
      })
    },
    resetPassword () {
      axios.post('profile/recoverPassword', {
        'full_search': this.full_search
      })
        .then(() => {
          this.$router.push('/confirmRecoverPassword')
        }).catch(error => {
          this.loading = false
          this.$notify(
            {
              message: error.response.data.error,
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
        })
    },
    getError (fieldName) {
      return this.$t(this.errors.first(fieldName))
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.login.$el.children[1].focus())
  }
}

</script>

<style lang="scss" scoped>
  .signin {
    max-width: 450px;
  }
  button[type=submit] {
    display: block;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
  }
  .form-text {
    flex: 0 0 100%;
    text-align: right;
  }
  .forgot-password-btn {
    padding: 0
  }
</style>
